/* Carrossel da capa: fade entre slides, setas, indicadores com barra de tempo,
   arraste no toque e pausa quando a seção sai da tela ou o mouse está em cima. */
(function () {
  'use strict';

  function init(hero) {
    if (hero.tdsHeroReady) return;
    hero.tdsHeroReady = true;

    var slides = Array.prototype.slice.call(hero.querySelectorAll('[data-tds-hero-slide]'));
    if (slides.length < 2) return;

    var dots = Array.prototype.slice.call(hero.querySelectorAll('[data-tds-hero-dot]'));
    var status = hero.querySelector('[data-tds-hero-status]');
    var prev = hero.querySelector('[data-tds-hero-prev]');
    var next = hero.querySelector('[data-tds-hero-next]');
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var autoplay = hero.dataset.autoplay === 'true' && !reduced;
    var interval = Number(hero.dataset.interval) || 6000;

    var index = 0;
    var timer = null;
    var paused = false;

    dots.forEach(function (dot) {
      dot.style.setProperty('--tds-dot-duration', interval + 'ms');
    });

    function render() {
      slides.forEach(function (slide, i) {
        var active = i === index;
        slide.classList.toggle('is-active', active);
        if (active) {
          slide.removeAttribute('aria-hidden');
        } else {
          slide.setAttribute('aria-hidden', 'true');
        }
      });

      dots.forEach(function (dot, i) {
        var active = i === index;
        dot.classList.remove('is-timing');
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-selected', active ? 'true' : 'false');
        if (active && autoplay && !paused) {
          /* reinicia a animação da barra */
          void dot.offsetWidth;
          dot.classList.add('is-timing');
        }
      });

      if (status) status.textContent = 'Slide ' + (index + 1) + ' de ' + slides.length;
    }

    function goTo(next_index) {
      index = (next_index + slides.length) % slides.length;
      render();
      schedule();
    }

    function schedule() {
      window.clearTimeout(timer);
      if (!autoplay || paused) return;
      timer = window.setTimeout(function () {
        goTo(index + 1);
      }, interval);
    }

    function pause() {
      paused = true;
      window.clearTimeout(timer);
      dots.forEach(function (dot) {
        dot.classList.remove('is-timing');
      });
    }

    function resume() {
      if (!paused) return;
      paused = false;
      render();
      schedule();
    }

    if (prev) {
      prev.addEventListener('click', function () {
        goTo(index - 1);
      });
    }
    if (next) {
      next.addEventListener('click', function () {
        goTo(index + 1);
      });
    }

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        goTo(i);
      });
    });

    hero.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        goTo(index - 1);
      } else if (event.key === 'ArrowRight') {
        event.preventDefault();
        goTo(index + 1);
      }
    });

    hero.addEventListener('mouseenter', pause);
    hero.addEventListener('mouseleave', resume);
    hero.addEventListener('focusin', pause);
    hero.addEventListener('focusout', function (event) {
      if (!hero.contains(event.relatedTarget)) resume();
    });

    /* Arraste horizontal no toque */
    var startX = null;
    var startY = null;
    hero.addEventListener(
      'touchstart',
      function (event) {
        startX = event.touches[0].clientX;
        startY = event.touches[0].clientY;
      },
      { passive: true }
    );
    hero.addEventListener(
      'touchend',
      function (event) {
        if (startX === null) return;
        var dx = event.changedTouches[0].clientX - startX;
        var dy = event.changedTouches[0].clientY - startY;
        if (Math.abs(dx) > 48 && Math.abs(dx) > Math.abs(dy)) {
          goTo(dx < 0 ? index + 1 : index - 1);
        }
        startX = null;
        startY = null;
      },
      { passive: true }
    );

    /* Fora da tela não precisa girar */
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              resume();
            } else {
              pause();
            }
          });
        },
        { threshold: 0.15 }
      ).observe(hero);
    }

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) {
        pause();
      } else {
        resume();
      }
    });

    render();
    schedule();
  }

  function initAll(root) {
    (root || document).querySelectorAll('[data-tds-hero]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
